import Modal from "react-bootstrap/Modal";

export const EventPromocodesModal = (props) => {
  const { setPromocode, promocode, show, apply, onHide } = props;
  const code = typeof promocode === "string" ? promocode.trim() : "";
  const canApply = code.length > 0;

  const handleApply = () => {
    if (!canApply) {
      return;
    }
    apply?.();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="event-promo-modal-title"
      centered
      dialogClassName="event-promo-modal-dialog"
      contentClassName="event-promo-modal"
    >
      <Modal.Header closeButton className="event-promo-modal-header">
        <Modal.Title id="event-promo-modal-title">Apply Promocode</Modal.Title>
      </Modal.Header>
      <Modal.Body className="event-promo-modal-body">
        <label className="event-promo-modal-label" htmlFor="checkout-promocode">
          Promocode
        </label>
        <input
          id="checkout-promocode"
          className="form-control event-promo-modal-input"
          type="text"
          value={code}
          onChange={(e) => setPromocode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleApply();
            }
          }}
          placeholder="Enter promocode"
          autoComplete="off"
          autoFocus
        />
      </Modal.Body>
      <Modal.Footer className="event-promo-modal-footer">
        <button
          type="button"
          className="event-promo-modal-btn-cancel"
          onClick={onHide}
        >
          Close
        </button>
        <button
          type="button"
          className="event-promo-modal-btn-apply"
          disabled={!canApply}
          onClick={handleApply}
        >
          Apply
        </button>
      </Modal.Footer>
    </Modal>
  );
};
